import { getBrandingUrls } from '../config/market'

const CRITICAL_LOGO_KEYS = [
  'toolbarWhite',
  'loginFlag',
  'loginSeal',
  'poweredByFred',
]

const APP_ASSETS_CACHE = 'app-assets'

/**
 * Allinea le chiavi Cache API a quelle usate dal browser e da Workbox (URL assoluto),
 * altrimenti `cache.match('/assets/...')` non trova le entry salvate con `http://origin/assets/...`.
 * @param {string} href
 * @returns {string}
 */
function toAbsoluteCacheUrl (href) {
  if (!href) return href
  if (/^https?:\/\//i.test(href)) {
    return href
  }
  return new URL(href, window.location.origin).href
}

/**
 * Pre-cache dei loghi branding per uso offline (stessa cache `app-assets` del service worker).
 */
export async function warmupLogoCache() {
  if (!('caches' in window)) {
    return
  }

  const brandingUrls = getBrandingUrls()
  const cache = await caches.open(APP_ASSETS_CACHE)

  const urls = CRITICAL_LOGO_KEYS.map((key) => brandingUrls[key])
    .filter(Boolean)
    .map(toAbsoluteCacheUrl)

  await Promise.allSettled(
    urls.map(async (absoluteUrl) => {
      const cached = await cache.match(absoluteUrl)
      if (cached) {
        return
      }
      const response = await fetch(absoluteUrl, { cache: 'reload' })
      if (response.ok) {
        await cache.put(absoluteUrl, response.clone())
      }
    }),
  )
}
